import * as angular from 'angular';

import { IDispatcherService, IDispatcher, } from '../';
import { IObjectAccessRightActionsService } from './objectAccessRights.actionCreator';
import { ObjectAccessRights } from '../../models';

export interface IObjectAccessRightsStoreService {
    getAll: (force?: boolean) => angular.IPromise<ObjectAccessRights[]>;
    updateOne: (target: ObjectAccessRights) => angular.IPromise<ObjectAccessRights[]>;
}

export interface IObjectAccessRightsActionDispatcherService extends IDispatcherService<IObjectAccessRightsStoreService> { }

export class ObjectAccessRightssActionDispatcherService implements IObjectAccessRightsActionDispatcherService {
    static serviceId = 'objectAccessRightsActionDispatcherService';

    static $inject = ['objectAccessRightActionsService'];

    constructor(private _actionService: IObjectAccessRightActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IObjectAccessRightsStoreService> {
        return {
            dispatcher: {
                getAll: (force?: boolean) => dispatch(this._actionService.getAll(force)),
                updateOne: (target: ObjectAccessRights) => dispatch(this._actionService.updateOne(target))
            }
        };
    }
}